import { render, staticRenderFns } from "./DSInputFields.vue?vue&type=template&id=658ce803&"
import script from "./DSInputFields.vue?vue&type=script&lang=js&"
export * from "./DSInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports